export const blobToFile = async(theBlob: Blob, fileName:string): Promise<File> => {
    
    const b: any = theBlob;
    
    b.lastModifiedDate = new Date();
    b.name = fileName;

    return <File>b;
};